'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('notebook', {
    url: '/notebook',
    template: '<notebook></notebook>'
  });
}



// WEBPACK FOOTER //
// ./client/app/notebook/notebook.routes.js